<template>
  <v-dialog v-model="show" :max-width="dialogMaxWidth" :fullscreen="isMobile">
    <product-group-dialog-content
      :product-group="productGroup"
      :sales-history="salesHistory"
      :editing-records="editingRecords"
      :is-loading="isLoading"
      :show="show"
      :is-mobile="isMobile"
      @close="show = false"
    ></product-group-dialog-content>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

import ProductGroupDialogContent from './ProductGroupDialogContent.vue'

export default {
  name: 'ProductGroupDialog',
  components: {
    ProductGroupDialogContent
  },
  computed: {
    ...mapState(
      {
        productGroup: state => state.product.productGroupDialog.productGroup,
        salesHistory: state => state.product.productGroupDialog.salesHistory,
        editingRecords: state => state.product.productGroupDialog.editingRecords,
        isLoading: state => state.product.productGroupDialog.isLoading,
        showDialog: state => state.product.productGroupDialog.show,
        isSmaller: state => state.product.productGroupDialog.isSmaller
      }
    ),
    show: {
      get () {
        return this.showDialog
      },
      set (value) {
        this.$store.commit('product/SET_SHOW_PRODUCT_GROUP_DIALOG', value)
      }
    },
    dialogMaxWidth: function () {
      return this.isSmaller ? '800px' : '900px'
    },
    isMobile: function () {
      return this.$vuetify.breakpoint.smAndDown
    }
  }
}
</script>
